module.exports = "<label\n    [htmlFor]=\"data.id\"\n    [ngClass]=\"showAsterisk ? 'required' : ''\"\n>\n    {{ data.label ? data.label : data.id }}\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/components/elements/label/label.component.html
// module id = ./libs/chassis-core/src/app/resources/components/elements/label/label.component.html
// module chunks = main